import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-2 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
}), 'MoveToInboxSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MoveToInboxSharp.js
// module id = 4934
// module chunks = 2